"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const get_1 = __importDefault(require("lodash/get"));
const Input_1 = __importDefault(require("../Input"));
function FormikInput(props) {
    const { name, style = { label: {}, input: {}, inputWrapper: {} }, onChange, type = 'text', className = '', value = null, checkErrorAfterInputTouched = true, mapOnChangeValue, mapValue, ...resProps } = props;
    const { values, handleChange, errors, touched, setFieldValue } = (0, formik_1.useFormikContext)();
    function changeHandler(e) {
        onChange?.(e);
        if (mapOnChangeValue) {
            void setFieldValue(name, mapOnChangeValue(e.target.value));
        }
        else {
            handleChange(e);
        }
    }
    let isInvalid = (0, get_1.default)(errors, name);
    if (checkErrorAfterInputTouched) {
        isInvalid = (0, get_1.default)(errors, name) && (0, get_1.default)(touched, name);
    }
    let val = value || (0, get_1.default)(values, name);
    val = mapValue ? mapValue(val) : val;
    return ((0, jsx_runtime_1.jsx)(Input_1.default, { name: name, value: val, onChange: changeHandler, type: type, style: {
            ...style,
            inputWrapper: {
                ...style.inputWrapper,
                ...(isInvalid
                    ? {
                        borderColor: 'red',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        outline: 'none',
                    }
                    : {}),
            },
        }, className: className, ...resProps }));
}
exports.default = FormikInput;
